export default __webpack_public_path__ + "static/media/icon_cancel_input_phone.0f2585ab.svg";